<template>
  <div class="orderDetailPage">
    <div class="con1">
      Order:<span class="num">{{ orderDetail.order_number }}</span>
    </div>
    <div class="con1-1" style="position: relative">
      <div class="con-status">In Progress</div>
      <div class="line1">
        <div class="left">
          Total：<span>$ {{ orderDetail.bid_amount }}
          </span><span class="funds" v-if="parseFloat(orderDetail.funds) !== 0">
            +{{ orderDetail.funds }}
          </span>
        </div>
      </div>
      <div class="line2">
        <div class="bl" :class="{ active: min >= 10 }"></div>
        <div class="bl" :class="{ active: min >= 20 }"></div>
        <div class="bl" :class="{ active: min >= 30 }"></div>
        <div class="bl" :class="{ active: min >= 40 }"></div>
        <div class="bl" :class="{ active: min >= 50 }"></div>
        <div class="bl" :class="{ active: min >= 60 }"></div>
        <div class="bl" :class="{ active: min >= 70 }"></div>
        <div class="bl" :class="{ active: min >= 80 }"></div>
        <div class="bl" :class="{ active: min >= 90 }"></div>
        <div class="bl" :class="{ active: min >= 100 }"></div>
      </div>

      <div class="box-line3" >
        <div>Released：${{ orderDetail.paid }}({{((orderDetail.paid/orderDetail.bid_amount).toFixed(2))*100}}%)</div>
        <div>Balance:${{ orderDetail.bid_amount }}</div>
      </div>
    </div>
    <!-- <div class="con2Container">
      <div class="con2">
        <div class="item1">
          <div class="top">
            ${{ orderDetail.bid_amount }}
            <span v-if="orderDetail.funds" class="tips">+ ${{ orderDetail.funds }}</span>
          </div>
          <div class="bottom">Total Amount</div>
        </div>
        <div class="item2">
          <div class="top">
            <el-image class="img" :src="orderDetail.user.head_picture"></el-image>
            <div class="name">{{ orderDetail.user.name }}</div>
          </div>
          <div class="bottom">Client Name</div>
        </div>
        <div class="item3">
          <div class="top">
            <el-image class="img" :src="orderDetail.writer.head_picture"></el-image>
            <div class="name">Elizabeth</div>
          </div>
          <div class="bottom">{{ orderDetail.writer.name }}</div>
        </div>
      </div>
      <div class="status">Bidding</div>
    </div> -->
    <div class="con3">
      <div class="top">
        <div class="item" @click="change(0)">
          <span class="a" :class="{ active: current === 0 }">Orders Details</span>
          <span class="b" v-show="current === 0"></span>
        </div>
        <div class="item pm" @click="change(1)">
          <span class="a" :class="{ active: current === 1 }">Payment</span>
          <span class="b" v-show="current === 1"></span>
        </div>
        <div class="item pm" @click="change(2)">
          <span class="a" :class="{ active: current === 2 }"> Feedback</span>
          <span class="b" v-show="current === 2"></span>
        </div>
      </div>
      <div class="bottom">
        <OrderDetail :orderDetail="orderDetail" v-if="current === 0"></OrderDetail>
        <Payment v-if="current === 1" :orderDetail="orderDetail"></Payment>
        <Feedback v-if="current === 2" :orderDetail="orderDetail"></Feedback>
      </div>
    </div>
    <div v-if="current === 0">
      <div class="con4">
        <div class="top">Upload Files</div>
        <div class="bottom">
          <FileList
            :showData="orderDetail.files ? orderDetail.files : []"
            :updateDownloadTime="true"
            @download="download"
          ></FileList>
        </div>
      </div>
      <!-- <div class="con4" v-if="orderDetail.status !== 1">
        <div class="top">Writer's Upload Files</div>
        <div class="bottom">
          <FileList :showData="orderDetail.writer_files ? orderDetail.writer_files : []"></FileList>
        </div>
      </div> -->
      <!-- v-else -->
      <div class="con5">
        <div class="top">Writer's Upload files</div>
        <div class="bottom">
          <FileList
            :showData="orderDetail.writer_files ? orderDetail.writer_files : []"
            :canDeleteFileItem="true"
            @deleteFileItem="deleteFileItem"
          ></FileList>
          <div class="b">
            <uploadTem :formAdditionalData="formAdditionalData" @onSuccess="onSuccess"></uploadTem>
          </div>
        </div>
      </div>
      <!-- <div class="con6" v-if="orderDetail.status === 1">
        <el-button size="small" type="primary" class="btn" @click="draft"
          >Application completed</el-button
        >
      </div> -->
    </div>
  </div>
</template>

<script>
import { getOrderDetail, editFiles, draft, downloadFileItem, apifileMessage } from '@/api/api.js';
import FileList from '@/components/file-list/file-list.vue';
import Person from '@/components/person/person.vue';
import OrderDetail from '../../../components/order-detail-page/order-detail.vue';
import Feedback from '../../../components/order-detail-page/feedback.vue';
import Payment from '../../../components/order-detail-page/payment.vue';
import uploadTem from '@/components/uploadTem/index.vue';

export default {
  name: 'processing',
  data: function () {
    return {
      current: 0,
      formAdditionalData: {
        type: 'order',
      },
      orderDetail: {
        writer: {},
      },
      value: 4,
      fileList: [],
      limit: 100,
    };
  },
  created() {
    this.$emit('change', 4);
    this.getOrderDetail(this.$route.query.orderId);
  },
  computed: {
    currentReleasePayment() {
      return (parseFloat(this.orderDetail.paid) / parseFloat(this.orderDetail.bid_amount)) * 100;
    },
    deadline() {
      return new Date(this.orderDetail.deadline * 1000).Format('yyyy-MM-dd hh:mm');
    },
  },
  methods: {
    async getOrderDetail(orderId) {
      let sendData = {
        id: orderId,
      };
      let result = await getOrderDetail(sendData);
      console.log('getOrderDetail result', result);
      result.writer.score = parseFloat(result.writer.score);
      result.writer_files = result.writer_files ? result.writer_files : [];
      this.orderDetail = result;
      console.log(this.orderDetail, 'this.orderDetail*------------');
      this.min = this.currentReleasePayment;
      this.max = 100;
    },
    change(index) {
      this.current = index;
    },
    formatTooltip(val) {
      return parseFloat((val / 100) * this.orderDetail.bid_amount) + '$';
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    async onSuccess(response, file, fileList) {
      console.log('response', response);
      console.log('file', file);
      console.log('fileList', fileList);
      if (response.code === 1) {
        if (!this.orderDetail.writer_files) this.orderDetail.writer_files = [];
        let postData = response.data;
        postData.upload_time = Date.parse(new Date());
        postData.url = response.data.key;
        // 去除文件名前的文件夹
        let str = response.data.key.split('/');
        postData.name = str[str.length - 1];
        postData.id = response.data.hash;

        this.orderDetail.writer_files.push(response.data);
        await this.editFiles();
        this.getOrderDetail(this.orderDetail.id);
      } else if (response.code === -1) {
        router.push({ name: 'login' });
      } else if (response.code === 0) {
        this.$message({
          type: 'warning',
          message: response.msg,
        });
      }
    },
    async deleteFileItem(index) {
      this.orderDetail.writer_files.splice(index, 1);
      await this.editFiles();
      this.getOrderDetail(this.orderDetail.id);
    },
    async editFiles() {
      let sendData = {
        id: this.orderDetail.id,
        files: this.orderDetail.writer_files,
      };
      let result = await editFiles(sendData);
      // 发起推送给商家
      await apifileMessage({
        order_id: this.orderDetail.id,
      });
      console.log('editFiles result', result);
    },
    async draft() {
      this.$confirm(
        'After sending the acceptance application, you need to wait for the acceptance of the order sender. Do you want to send the application?',
        'Hint',
        {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning',
        },
      )
        .then(async () => {
          let result = await draft(sendData);
          console.log('draft result', result);
          const h = this.$createElement;
          this.$notify({
            title: 'Tips',
            message: h(
              'i',
              { style: 'color: teal' },
              'The acceptance application has been submitted, please wait for the order creator to review.',
            ),
          });
          this.getOrderDetail(this.orderDetail.id);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Cancelled',
          });
        });
      let sendData = {
        id: this.orderDetail.id,
      };
    },
    async download(id) {
      console.log('download id', id);
      let sendData = {
        id: this.orderDetail.id,
        files_id: id,
      };
      let result = await downloadFileItem(sendData);
      console.log('download result', result);
      this.getOrderDetail(this.orderDetail.id);
    },
  },
  components: { FileList, Person, OrderDetail, Feedback, Payment, uploadTem },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/writer.scss';

.orderDetailPage {
  .con1 {
    font-size: 25px;
    font-weight: bold;
    color: #000000;
    letter-spacing: 1px;
    .num {
      margin-left: 10px;
    }
  }
  .con2Container {
    margin-top: 20px;
    background-color: #fff;
    position: relative;
    border-radius: 10px;
    padding: 30px 0;
    .con2 {
      display: flex;
      justify-content: space-between;
      align-content: center;
      [class^='item'] {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
        justify-content: center;
        .bottom {
          margin-top: 5px;
        }
      }
      .item1 {
        .top {
          font-size: 30px;
          font-weight: bold;
          color: #000000;
          line-height: 42px;
        }
        .bottom {
          font-size: 16px;
          font-weight: 400;
          color: #000000;
          line-height: 22px;
        }
      }
      .item2,
      .item3 {
        .top {
          display: flex;
          align-items: center;
          .img {
            width: 34px;
            height: 34px;
            border-radius: 50%;
          }
          .name {
            font-size: 22px;
            font-weight: bold;
            color: #000000;
            line-height: 28px;
            margin-left: 8px;
          }
        }
        .bottom {
          font-size: 16px;
          font-weight: 400;
          color: #000000;
          line-height: 22px;
        }
      }
    }
    .status {
      position: absolute;
      right: 0;
      top: 0;
      width: 86px;
      height: 30px;
      background: rgba($color: #577cf2, $alpha: 0.18);
      border-radius: 0px 10px 0px 10px;
      line-height: 30px;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: #577cf2;
    }
  }
  .con3 {
    .top {
      padding: 20px;
      background-color: #e8ebf1;
      border-radius: 10px 10px 0 0;
      margin-top: 30px;
      display: flex;
      .item {
        cursor: pointer;
        display: flex;
        align-items: center;
        .a {
          min-width: 97px;
          height: 21px;
          font-size: 18px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #9b9b9b;
          line-height: 21px;
        }
        .a.active {
          font-size: 18px;
          font-family: Roboto-Bold, Roboto;
          font-weight: bold;
          color: #000000;
          line-height: 21px;
        }
        .b {
          display: inline-block;
          width: 8px;
          height: 8px;
          background: #8ce030;
          border-radius: 50%;
          margin-left: 10px;
        }
      }
      .item.pm {
        margin-left: 70px;
      }
    }
    .bottom {
      position: relative;
      top: -10px;
    }
  }
  .con4 {
    margin-top: 20px;
    .top {
      background-color: #e8ebf1;
      border-radius: 10px;
      padding: 20px;
      font-size: 25px;
      font-family: Roboto-Bold, Roboto;
      font-weight: bold;
      color: #112a75;
    }
    .bottom {
      position: relative;
      top: -10px;
      padding: 30px;
      background-color: #fff;
      border-radius: 10px;
    }
  }
  .con5 {
    margin-top: 20px;
    .top {
      background-color: #e8ebf1;
      border-radius: 10px;
      padding: 20px;
      font-size: 25px;
      font-family: Roboto-Bold, Roboto;
      font-weight: bold;
      color: #112a75;
    }
    .bottom {
      position: relative;
      top: -10px;
      padding: 30px;
      background-color: #fff;
      border-radius: 10px;
      .b {
        margin-top: 10px;
        background: rgba(87, 124, 242, 0.1);
        padding: 30px;
        border-radius: 10px;
        .upload-demo {
          margin-top: 20px;
          text-align: center;
          ::v-deep .el-upload.el-upload--text {
            width: 100%;
            .el-upload-dragger {
              width: 100%;
            }
          }
          .upload {
            width: 142px;
            height: 42px;
            background: #577cf2;
            border-radius: 10px;
            font-size: 18px;
            font-family: Roboto-Medium, Roboto;
            font-weight: 500;
            color: #ffffff;
          }
        }
      }
    }
  }

  .con6 {
    margin-top: 30px;
    text-align: center;
    .btn {
      width: 230px;
      height: 42px;
      background: $writerTheme;
      border-color: $writerTheme;
      border-radius: 10px;
      font-size: 18px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: #ffffff;
    }
  }
}
</style>
<style lang="scss" scoped>
.showContent {
  padding: 10px;
  width: 239px;
  background: #d0d0d0;
  font-size: 16px;
  font-family: Roboto-Thin, Roboto;
  font-weight: 100;
  color: #141414;
  line-height: 24px;
  cursor: pointer;
}

.showContent2 {
  padding: 10px;
  font-size: 12px;
  font-family: Roboto-Regular, Roboto;
  font-weight: 400;
  color: #000000;
  line-height: 24px;
  cursor: pointer;
}

.myDialog {
  .center {
    text-align: center;
  }
}

.tips {
  margin-left: 15px;
  font-size: 20px;
  color: #ff8080;
}

.con1-1 {
  padding: 30px;
  background-color: #fff;
  border-radius: 10px;
  margin-top: 20px;
  .line1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      font-size: 36px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #000000;
      span {
        font-size: 36px;
        font-family: Roboto-Bold, Roboto;
        font-weight: bold;
        color: #000000;
      }
      .funds {
        margin-left: 15px;
        font-size: 25px;
        color: #ff8080;
      }
    }
    .right {
      .btn {
        width: 138px;
        height: 42px;
        background: #577cf2;
        border-radius: 10px;
        border: 2px solid #577cf2;
        margin-left: 30px;
        color: white;
      }
    }
  }
  .line2 {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    .bl:not(:first-child) {
      margin-left: 10px;
    }
    .bl {
      width: 13%;
      height: 9px;
      background: #eaecee;
    }
    .bl.active {
      background: #b2c2f3;
    }
  }
}

.con-status {
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 10px 30px;
  background: #ffefeb;
  color: #f0a58e;
  border-radius: 0px 10px 0px 0px;
}
.box-line3 {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  font-size: 16px;
  color: #999;
}
</style>
